export default function (props: any) {
    return (
        <svg width="58px" height="59px" viewBox="0 0 58 59" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-741.000000, -8087.000000)">
                    <g transform="translate(741.000000, 8087.741000)">
                        <rect x="0" y="0" width="58" height="58"></rect>
                        <g transform="translate(6.900000, 12.100000)" stroke="#FFFFFF" strokeWidth="1.7">
                            <polyline
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                points="28.0783619 32.5 28.0783619 28.6 16.3783619 28.6 16.3783619 32.5"
                            ></polyline>
                            <path d="M2.32645581,0 L41.8735442,0 C43.158482,0 44.2,1.06705739 44.2,2.38350368 L44.2,26.5558287 C44.2,27.6848927 43.3067953,28.6 42.2047549,28.6 L2.32645581,28.6 C1.04151795,28.6 0,27.5329426 0,26.2164963 L0,2.38350368 C0,1.06705739 1.04151795,0 2.32645581,0 Z"></path>
                            <line x1="10.1457924" y1="33.15" x2="33.5457924" y2="33.15" strokeLinecap="round" strokeLinejoin="round"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
